/* import __COLOCATED_TEMPLATE__ from './permissions-section.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();